import React, { useState } from 'react';
import MainCard from '../../../components/MainCard/MainCard';
import { Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import RelatorioColetasSintetica from './RelatorioColetasSintetica';

//Api
import relatorio_api from '../../../api/relatorio_api';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';


function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");

    return {
        dataInicial,
        dataFinal,
        nomeRelatorio: "Relatórios - Coletas Sintético"
    }
}

export default function ColetasSintetica() {

    //Variavel utilizada para navegação 
    const navigate = useNavigate();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);


    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);


    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

   
    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

        setLoading(true);
        relatorio_api.ColetasSintetica(filtros).then(response => {
            setDadosRelatorio(response.data);
        })
        .catch(e => showMessage("Aviso", e.message, "error", null))
        .finally(f => setLoading(false));
    }
  
    if (dadosRelatorio) {
        return <RelatorioColetasSintetica
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio(null)}
            filtros={filtros}
        />
    }

    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório de coletas sintética</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}